import React from 'react'
import Link from 'gatsby-link'

const SecondPage = () => (
  <div>
    <div className='Instruction'>
      <div className='InstructionGroup'>
        <h1>Step 4: Clean acquired data</h1>
<progress value="80" max="100">80 %</progress>
        <p>* We've missed an important step in AI training: data cleaning, i.e., fixing or removing incorrect, corrupted, incorrectly formatted, duplicate, or incomplete data within a dataset. By cleaning the training data, we're likely to reduce biases contained. 
        </p>
        <p>* Please modify the sentences or add new sentences in the dataset locally, and then upload the new dataset. Your main goal is to make the dataset more fair in terms of gender. 
        </p>
        <h2>
           <a href="https://drive.google.com/file/d/1iWIcNAM3PbmYxn-Am9sNIjQsO3oUzqHe/view?usp=sharing" title="Dataset" target="_blank">Dataset</a>
        </h2>
        <p>* Now let's run the code again and see what changes! Again, please run Google Colab below to see the newly predicted next word given the prompt of either "man" or "woman." After you go to Google Colab, select "Runtime->Run all". Under the section "Training with Bias", type either "man" or "woman" as the prompt and observe the next word. Repeat the process 10 times, 5 times with the prompt "man", and 5 times with "woman". Are there any changes compared to last time?
        </p>
        <h2>
          <a href="https://colab.research.google.com/drive/1hkzl1RfUJYYPaiDlos9ER6rYX4QJ9sTY?usp=sharing" title="Colab" target="_blank">Colab</a>
        </h2>
        <p>We're not done yet!
        </p>
        <Link to="/3-rf/">Back</Link>
        <Link to="/5-unawareness/">Next step</Link>		
        <Link to="/">Go back to the homepage</Link>
      </div>
    </div>
  </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/4-clean.js